import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const InvitedUsersFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.invitedUsers.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
